"use client";

// import { getAOSAnimation } from "@litonarefin/utils/getAOSAnimation";
import { getBorderCSS } from "@litonarefin/utils/getBorderCSS";
import { getDimensionCSS } from "@litonarefin/utils/getDimensionCSS";
// freemius-checkout-js is imported lazily in getFsCheckout() rather than at
// module scope. A static import pulls the whole checkout SDK into the client
// bundle of every route that can render a block — including blog posts, which
// never show a buy button.
import { useEffect, Fragment, useRef, Suspense } from "react";
import { useRouter } from "next/navigation";

const FreemiusButton = ({ attributes }) => {
  const router = useRouter();

  const {
    pricingTableId,
    productName,
    pluginId,
    billingCycle,
    publicKey,
    planId,
    isCoupon,
    couponCode,
    numberOfLicenses,
    productImageURL,
    btnColor,
    btnBgColor,
    border,
    borderRadius,
    padding,
    width,
  } = attributes;

  // const allAOS = getAOSAnimation(attributes);

  const btnRef = useRef(null);
  const fsCheckoutRef = useRef(null);

  /**
   * Load the SDK and build the checkout instance on first use, then reuse it.
   */
  const getFsCheckout = async () => {
    if (!fsCheckoutRef.current) {
      const { FSCheckout } = await import("freemius-checkout-js");

      fsCheckoutRef.current = new FSCheckout({
        plugin_id: pluginId,
        public_key: publicKey,
        plan_id: planId,
        image: productImageURL,
      });
    }

    return fsCheckoutRef.current;
  };

  /**
   * Open Checkout
   * @param {*} e
   */
  const getCheckout = async (e) => {
    e.preventDefault();
    // Check DOM set Attributes PlanId & License. Read before awaiting the SDK
    // so the values survive the button unmounting mid-load.
    const domPlanId = btnRef.current?.getAttribute("plan_id");
    const domLicenses = btnRef.current?.getAttribute("license");

    const fsCheckout = await getFsCheckout();

    // Checkout Freemius
    fsCheckout.open({
      billing_cycle: billingCycle,
      plan_id: domPlanId || planId,
      licenses: domLicenses || numberOfLicenses,
      title: productName,
      coupon: couponCode,
      hide_coupon: isCoupon,
      success: (data) => {},
      // Purchase Completed
      purchaseCompleted: function (response) {
        var isTrial = null != response.purchase.trial_ends,
          isSubscription = null != response.purchase.initial_amount,
          total = isTrial
            ? 0
            : (isSubscription
                ? response.purchase.initial_amount
                : response.purchase.gross
              ).toString(),
          productName = "WP Adminify",
          storeUrl = "https://wpadminify.com",
          storeName = "WP Adminify";

        // Facebook Pixel
        if (typeof fbq !== "undefined") {
          fbq("track", "Purchase", {
            currency: response.purchase.currency.toUpperCase(),
            value: total,
          });
        }

        // Carry the real order total to /thank-you so the AdRoll pixel can
        // record the purchase revenue on the conversion page (see
        // shared/pages/thank-you/AdRollPurchase).
        try {
          sessionStorage.setItem(
            "jlt_purchase",
            JSON.stringify({
              conversion_value: total,
              currency: response.purchase.currency.toUpperCase(),
              order_id: response.purchase.id,
            })
          );
        } catch (e) {}

        setTimeout(() => {
          router.push("/thank-you");
        }, 3000);
      },
    });
  };

  useEffect(() => {
    // close and destroy the DOM related stuff on unmount. The instance only
    // exists if the button was actually clicked.
    return () => {
      fsCheckoutRef.current?.close();
      // fsCheckoutRef.current?.destroy();
    };
  }, []);

  // Was an early return above the hooks, which changed hook order between
  // renders whenever pluginId appeared or disappeared.
  if (!pluginId) return null;

  return (
    <Fragment>
      <Suspense>
        <button
          ref={btnRef}
          className="jlt-freemius-btn jlt-shadow-[0px_0px_20px_rgba(173,173,188,0.15)] jlt-rounded-[25px] jlt-py-3 jlt-px-6 jlt-font-bold jlt-text-sm jlt-leading-[18px] jlt-text-center jlt-text-white jlt-border-none jlt-cursor-pointer"
          // {...allAOS}
          onClick={(e) => getCheckout(e)}
          id={pricingTableId}
        >
          {attributes?.btnText || "Button Text"}
        </button>
        <style jsx>{`
          .jlt-freemius-btn {
            ${btnBgColor ? `background: ${btnBgColor};` : ""}
            ${btnColor ? `color: ${btnColor};` : ""}
                    ${borderRadius ? `border-radius: ${borderRadius}px;` : ""}
                    ${width ? `width: ${width};` : ""}
                    ${getBorderCSS(border) ? getBorderCSS(border) : ""}
                    ${getDimensionCSS(padding, "padding")
              ? getDimensionCSS(padding, "padding")
              : ""}
          }
        `}</style>
      </Suspense>
    </Fragment>
  );
};

export default FreemiusButton;
